var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 3.20888 7.7654 2.43552 7.32588 1.77772C6.88635 1.11992 6.26164 0.607234 5.53073 0.304484C4.79983 0.00173315 3.99556 -0.0774802 3.21964 0.0768607C2.44372 0.231201 1.73098 0.612164 1.17157 1.17157C0.612164 1.73098 0.231201 2.44372 0.0768607 3.21964C-0.0774802 3.99556 0.00173315 4.79983 0.304484 5.53073C0.607234 6.26164 1.11992 6.88635 1.77772 7.32588C2.43552 7.7654 3.20888 8 4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4ZM5.79964 5.28582L5.28545 5.8L4 4.51418L2.71455 5.8L2.20036 5.28582L3.48582 4L2.20036 2.71455L2.71455 2.20036L4 3.48582L5.28545 2.20036L5.79964 2.71455L4.51418 4L5.79964 5.28582Z",
    fill: "#F9413E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxFailed);
export default __webpack_public_path__ + "static/media/tx-failed.a5480511.svg";
export { ForwardRef as ReactComponent };